import script from "./FeedSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedSetup.vue?vue&type=script&setup=true&lang=js"

import "./FeedSetup.vue?vue&type=style&index=0&id=a1d8678e&scoped=true&lang=css"
import "./FeedSetup.vue?vue&type=style&index=1&id=a1d8678e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1d8678e"]])

export default __exports__